const demo = 'https://me-demo.arkia.pro:444'; //demo
const pro = 'https://apime.arkia.pro'; //produccion
const back = 'http://localhost:21021'; //back
const qa = 'https://apime-qa.arkia.pro'; //Externa
const dev = 'https://me-dev.arkia.pro:444/' //Dev

const getHost = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'PRO': return pro;
    case 'DEMO': return demo;
    case 'BACK': return back;
    case 'DEV': return dev;
    case 'QA': return qa;
    default: return pro; // Default case for dev local
  }
}

async function fetchAsync(url, typeOfPetition, bodyData, controller, withAuthorization = true, arkiaPro = false) {

  const method = typeOfPetition !== undefined ? typeOfPetition : 'GET';
  const data = bodyData || null;



  const headers = withAuthorization ?
    new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `bearer ${window.localStorage.getItem('accessToken')}`,
      'Cache-Control': 'no-cache',
    })
    :
    new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Cache-Control': 'no-cache',
    });


  const request = {
    method,
    headers,
  };

  if ('AbortController' in window) {
    if (controller) {
      request.signal = controller.signal;
    } else {
      const fetchController = new window.AbortController();
      request.signal = fetchController.signal;
    }
  }

  if (data) {
    request.body = JSON.stringify(data);
  }
  let host = getHost();
  if (arkiaPro) {
    host = 'https://arkia-dev.arkia.pro:444'
  }
  const response = await fetch(`${host}/api/${url}`, request);

  return response;

}

const CallExcepcion = function ({ status = 500, statusText = 'Petition Failed' }, url, streamResponse) {
  this.url = url;
  this.status = status;
  this.statusText = statusText;
  this.streamResponse = streamResponse;
};

function validateResponse(response, url) {
  if (response.error || !response.ok) {
    throw new CallExcepcion(response, url, response);
  }
  return null;
}


export default {
  fetchAsync,
  validateResponse,
  getHost,
};


